import { TaskCalendarStatus } from "./types";

export const SCHEDULE_STATUS_COLORS: Record<string, string> = {
  [TaskCalendarStatus.FAILED]: "bg-red-400",
  [TaskCalendarStatus.COMPLETED]: "bg-green-500",
  [TaskCalendarStatus.PENDING]: "bg-yellow-400",
  [TaskCalendarStatus.ACTIVE]: "bg-green-500",
  [TaskCalendarStatus.INACTIVE]: "bg-gray-400",
};
